import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function Container({
  children,
  className,
  id,
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) {
  return (
    <div
      className={twMerge(
        'mx-auto my-8 max-w-screen-2xl overflow-x-hidden px-4 sm:my-14 sm:px-8 lg:my-16',
        className,
      )}
      id={id}
    >
      {children}
    </div>
  );
}
